import React from 'react';
import { string } from 'prop-types';
import { FaCcVisa, FaCcDiscover } from 'react-icons/fa';
import { FaCreditCard } from 'react-icons/fa6';
import { SiMastercard, SiAmericanexpress } from 'react-icons/si';

const VISA = 'visa';
const MASTERCARD = 'mastercard';
const AMERICAN_EXPRESS = 'american_express';
const DISCOVER = 'discover';

function WalletPaymentMethodIcon({ brand }) {
    if (brand === VISA) {
        return <FaCcVisa />;
    }
    if (brand === MASTERCARD) {
        return <SiMastercard />;
    }
    if (brand === AMERICAN_EXPRESS) {
        return <SiAmericanexpress />;
    }
    if (brand === DISCOVER) {
        return <FaCcDiscover />;
    }
    return <FaCreditCard />;
}

WalletPaymentMethodIcon.propTypes = {
    brand: string,
};

export default WalletPaymentMethodIcon;